__turbopack_context__.v({
  "progress-button": "styles-module__og7Osq__progress-button",
  "row-stretch-centered": "styles-module__og7Osq__row-stretch-centered",
});
